import { render, staticRenderFns } from "./CustomerHeaderMobile.vue?vue&type=template&id=7144dca5&scoped=true&"
import script from "./CustomerHeaderMobile.vue?vue&type=script&lang=js&"
export * from "./CustomerHeaderMobile.vue?vue&type=script&lang=js&"
import style0 from "./CustomerHeaderMobile.vue?vue&type=style&index=0&id=7144dca5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7144dca5",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QHeader,QToolbar,QBtn})
